import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";
import { Actions, Mutations } from "@/store/enums/StoreEnums";

export interface SiteInfo {
    sites : Record<any, any>,
    selectedSiteId: number | null
}

@Module
export default class SiteModule extends VuexModule implements SiteInfo {
    sites = [] as Record<any, any>
    selectedSiteId: number | null = null;
    
    get getAllSites(): Record<any, any>{
        return this.sites
    }

    get getSelectedSiteId(): number | null {
        return this.selectedSiteId;
    }

    @Mutation
    [Mutations.ALL_SITES](sites: Record<any, any>){
        this.sites = sites
    }

    @Mutation
    setSelectedSiteId(siteId: number) {
        this.selectedSiteId = siteId;
    }

    @Action({ rawError: true })
    setSelectedSite(siteId: number) {
        this.context.commit('setSelectedSiteId', siteId);
    }

    @Action({ rawError: true })
    [Actions.SET_SITES](sites: Record<any, any>) {
        this.context.commit(Mutations.ALL_SITES, sites)
    }
}
